class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.isDesktop = window.matchMedia('(min-width: 990px)');

    this.closeBtn = this.querySelector('.destionations__close-btn');

    // Add hover listeners for desktop only
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    if (!this.closeBtn) return;
    this.closeBtn.addEventListener('click', this.onMouseLeave.bind(this));
  }

  connectedCallback() {
    const init = () => {
      this.dropdownNavSource = window.__dropdownNavSource || 'default';

      if (this.dropdownNavSource === 'VWO') {
        this.classList.add(`${window.__dropdownNavSource}__header-menu`);
      }
    };

    this.initCallback = init;
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', this.initCallback)
      : init();
  }

  onMouseEnter() {
    // Only enable hover on desktop
    if (!this.isDesktop.matches) return;

    // Clear any pending close timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // Open the megamenu
    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.open = true;
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    }
  }

  onMouseLeave() {
    // Only enable hover on desktop
    if (!this.isDesktop.matches) return;

    // Delay closing to prevent accidental closure
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '')
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);
